"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationModalWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var reactstrap_1 = require("reactstrap");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var portal_core_1 = require("@ferry/portal-core");
var NotificationModalWidget = /** @class */ (function (_super) {
    __extends(NotificationModalWidget, _super);
    function NotificationModalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.hideModal = function () {
            _this.setState({
                show: false
            });
            _this.executeEvent("blur");
        };
        _this.state = {
            show: true
        };
        return _this;
    }
    NotificationModalWidget.prototype.render = function () {
        var title = this.getSetting("title");
        var titleCssClass = this.getSetting("titleCssClass");
        var content = this.renderHtml(this.getSetting("content"));
        var type = this.getSetting("type", "warning");
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "notification-warning-modal", isOpen: this.state.show, toggle: this.hideModal, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.hideModal, children: title && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [type === "warning" &&
                                (0, jsx_runtime_1.jsx)("img", { className: "notification-warning-icon padding-warning", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/alert-yellow.svg"), alt: "Warning icon" }), type === "info" &&
                                (0, jsx_runtime_1.jsx)("img", { className: "info-icon-selected", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/info-popup.svg"), alt: "Info icon" }), (0, jsx_runtime_1.jsx)("span", { className: titleCssClass || "text-blue-2 font-weight-medium", children: title })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { children: content }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { className: "justify-content-center", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-next", onClick: this.hideModal, children: "Ok, I understand" }) })] }));
    };
    NotificationModalWidget.prototype.renderInputField = function () {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    NotificationModalWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "title", type: journey_model_1.TypeDescriptions.String },
            { name: "titleCssClass", type: journey_model_1.TypeDescriptions.String },
            { name: "content", type: journey_model_1.TypeDescriptions.String },
            { name: "type", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], NotificationModalWidget);
    return NotificationModalWidget;
}(plugin_journey_1.QuestionWidgetBase));
exports.NotificationModalWidget = NotificationModalWidget;
//# sourceMappingURL=NotificationModalWidget.js.map